/**
 * Created by: cmarin
 * Date: 02.12.2013
 */

(function ($) {
    'use strict';

    var ui = kendo.ui,
        Widget = ui.Widget,
        DatePicker = ui.DatePicker,
        CLOSE = "close",
        ENABLE = "enable",
        ISOPEN = "isOpen",
        OPEN = "open",
        VALUE = "value",
        TEXT = "text",
        MAX = "max",
        MIN = "min",
        READONLY = "readonly",
        unwrap = TS.unwrap;

    // CP 20140702
    // convert a kendo display format to dateEntry plugin format
    // see http://keith-wood.name/dateEntry.html
    // e.g.: dd.MM.yyyy -> dmy.
    function getMaskFormat(displayFmt) {
        var fmt = '',
            i = 0,
            len = (displayFmt || '').length,
            c, sep,
            toFind = ['d', 'm', 'y'],
            found = [];

        // detect unique date part chars in format
        // and separator
        for(; i<len; i++) {
            c = displayFmt.charAt(i).toLowerCase();

            if (toFind.indexOf(c) != -1) {
                if(found.indexOf(c) == -1) {
                    found.push(c);
                }
            } else {
                if (!sep) {
                    sep = c;
                }
            }
        }

        $.each(found, function(idx, c) {
            fmt += c;
        });

        if (sep) {
            fmt += sep;
        }

        return fmt;
    }

    var TsDatePicker = DatePicker.extend({

        init: function (element, options) {
            var that = this,
                strVal, date,
                maskFormat;

            strVal = options.value;
            if (TS.isString(strVal)) {
                date = kendo.parseDate(strVal, options.parseFormats, options.culture);
                options.value = date;
            }

            DatePicker.fn.init.call(this, element, options);

            // CP 20140702 - replaced maskedInput plugin with dateEntry
            maskFormat = getMaskFormat(options.format);
            that.element.dateEntry({ dateFormat: maskFormat, spinnerImage: null });
        },

        options: {
            name: 'TsDatePicker',
            autoBind: false,
            animate: false
        }
    });

    ui.plugin(TsDatePicker);

    /*
        TsDatePicker
    */
    ko.kendo.bindingFactory.createBinding({
        name: "kendoTsDatePicker",
        defaultOption: VALUE,
        events: {
            change: VALUE,
            open:
            {
                writeTo: ISOPEN,
                value: true
            },
            close: {
                writeTo: ISOPEN,
                value: false
            }
        },
        watch: {
            enabled: ENABLE,
            readonly: READONLY,
            max: MAX,
            min: MIN,
            value: VALUE,
            isOpen: [OPEN, CLOSE],
            visible: ko.wrapperVisible
        }
    });

    //CP 20130529 - intercept the setup function to pass along the viewModel to widget options
    var prevDatePickerSetup = ko.bindingHandlers['kendoTsDatePicker'].setup;
    ko.bindingHandlers['kendoTsDatePicker'].setup = function (element, options, context) {

        // bindingFactory converts observables to JS in getWidget
        // so create a closure to hold the reference to our viewModel
        // widget = $element[widgetConfig.name](-->  ko.toJS(options)  <---  ).data(widgetConfig.name);
        options.getViewModel = function() {
            var vm = context.$data;   // PBS: use $data instead of $root to expose proper context in foreach bindings
            return vm;
        };

        options.animate = false;

        prevDatePickerSetup.apply(this, arguments);
    }

})(jQuery);